(function () {
  'use strict';
  class HistItemCtrl {
    constructor(OcorrenciasEnum, $filter, $translate, HttpServiceV3g, AlertMessage, Authenticator, MeasurementUnitConverterService) {
      this.authenticator = Authenticator;
      this.measurementUnitConverterService = MeasurementUnitConverterService;
      this.ocorrenciasEnum = OcorrenciasEnum;
      this.filter = $filter;
      this.teste = null;
      this.translate = $translate;
      this.statusI18N = '<strong> ' + this.translate.instant('ce.tempoReal.quadroDeOcorrencias.historicoItem.status') + ' </strong>';
      this.responsavelI18N = '<strong> ' + this.translate.instant('ce.tempoReal.quadroDeOcorrencias.historicoItem.responsavel') + ' </strong>';
      this.observacaoI18N = '<strong> ' + this.translate.instant('ce.tempoReal.quadroDeOcorrencias.historicoItem.observacao') + ' </strong>';
      this.anexoI18N = '<strong> ' + this.translate.instant('ce.tempoReal.quadroDeOcorrencias.historicoItem.anexo') + ' </strong>';
      this.asI18N = this.translate.instant('ce.tempoReal.quadroDeOcorrencias.common.as');
      this.usuarioAtribuidoNenhumI18N = this.translate.instant('ce.tempoReal.quadroDeOcorrencias.historicoItem.usuarioAtribuidoNenhum');
      this.httpService = HttpServiceV3g;
      this.alertMessage = AlertMessage;
      this.mapUuidUrl = new Map();
    }

    $onInit() {
      if (this.item.statusAnterior) {
        this.statusAnterior = this.ocorrenciasEnum.getStatusById(this.item.statusAnterior).descricao;
        this.statusNovo = this.ocorrenciasEnum.getStatusById(this.item.statusNovo).descricao;
      }
      const isComentarioKey = this.isTranslationKey(this.item.comentario), isUsarioKey = this.isTranslationKey(this.item.usuario.login);

      this.comentario = isComentarioKey ? this.translate.instant(this.item.comentario) : this.item.comentario;
      this.usuario = isUsarioKey ? this.translate.instant(this.item.usuario.login) : this.item.usuario.login;
      this.dateFormat = 'dd/MM/yyyy';
      this.dataHora = this.filter('date')(this.item.dataHora, this.dateFormat) + ' ' + this.asI18N + ' ' +
            this.filter('date')(this.item.dataHora, 'HH:mm');
      this.authenticator.getUser().then((user) => {
        this.user = user;
        this.userPreferredDateFormat = user.measurementUnits && user.measurementUnits.dateTimeFormat || 'BRITISH';
        this.dateFormat = this.measurementUnitConverterService.getDateFormat(this.userPreferredDateFormat);
        this.updateDataHora();
      });

      if (this.item.usuarioAtribuidoAnterior || this.item.usuarioAtribuidoNovo) {
        const isUsuarioAtribuidoAnteriorKey = this.item.usuarioAtribuidoAnterior ? this.isTranslationKey(this.item.usuarioAtribuidoAnterior.login) : false;
        this.resNovo = this.item.usuarioAtribuidoNovo ? this.item.usuarioAtribuidoNovo.login : this.usuarioAtribuidoNenhumI18N;
        this.resAnterior = this.item.usuarioAtribuidoAnterior ? this.getUsuarioAtribuidoAnteriorLogin(isUsuarioAtribuidoAnteriorKey) : this.usuarioAtribuidoNenhumI18N;
      }
    }

    updateDataHora() {
      this.dataHora = this.filter('date')(this.item.dataHora, this.dateFormat) + ' ' + this.asI18N + ' ' +
            this.filter('date')(this.item.dataHora, 'HH:mm');
    }

    getUsuarioAtribuidoAnteriorLogin(isKey) {
      return isKey ? this.translate.instant(this.item.usuarioAtribuidoAnterior.login) : this.item.usuarioAtribuidoAnterior.login;
    }

    isTranslationKey(key) {
      return this.translate.instant(key) !== key;
    }

    downloadAnexo(uuid, nome) {
      const url = this.mapUuidUrl.get(uuid);
      if (angular.isDefined(url)) {
        this.createAnchorElementAndClick(url, nome);
      } else {
        this.httpService.get(`/anexo/anexos/${uuid}/download?entidadeId=${this.veiculoId}`)
          .then((fileDownloadUrl) => {
            if (fileDownloadUrl && fileDownloadUrl.data.url) {
              const urlDownload = fileDownloadUrl.data.url;
              this.mapUuidUrl.set(uuid, urlDownload);
              this.createAnchorElementAndClick(urlDownload, nome);
            }
          })
          .catch(() => {
            this.alertMessage.create({
              type: 'error',
              message: this.translate.instant('ce.tempoReal.quadroDeOcorrencias.historicoItem.erroUrlAnexo'),
              appendTo: '.alerta-aqui-anexo'
            });
          });
      }
    }

    createAnchorElementAndClick(url, nome) {
      const anchor = angular.element('<a/>');
      anchor.attr({
        href: url,
        download: nome
      })[0].click();
    }
  }

  angular
    .module('quadroOcorrencias')
    .component('histItem', {
      controller: HistItemCtrl,
      templateUrl: 'quadro-ocorrencias/ocorrencia-modal/hist-item/hist-item.tpl.html',
      bindings: {
        item: '=',
        veiculoId: '='
      }
    });
}());
